import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updateShipmentOrderHistory } from '../api'
import { shipmentOrderHistoriesQueryKeys } from '../query-keys'

export const useUpdateShipmentOrderHistoryMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateShipmentOrderHistory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: shipmentOrderHistoriesQueryKeys.all
      })
    }
  })
}
